<template>
  <div class="panel">
    <div v-if="hasFailed" class="notice">Les données n'ont pas pu être chargées. Rechargez la page.</div>
    <div v-else-if="data" class="content" :class="{stale: isLoading}">
      <slot :data="data" :reload="fetch" :refresh="refresh" />
    </div>
    <div v-if="isLoading" class="loading">Chargement…</div>
  </div>
</template>

<script>
/**
 * Charge les données d'une page de l'espace super admin, puis les donne au contenu, avec de quoi les recharger :
 * <AdministrationPanel :load="..." v-slot="{ data, reload }">.
 */
export default {
  name: 'AdministrationPanel',
  props: {
    // Appel du back, ex : AdministrationController.getOverview
    load: {type: Function, required: true},
  },
  data() {
    return {
      data: undefined,
      isLoading: false,
      hasFailed: false,
      requestId: 0,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    async fetch(silent = false) {
      // Une réponse tardive d'une ancienne demande ne doit pas écraser la dernière
      const requestId = ++this.requestId;
      // Une actualisation silencieuse ne grise pas la page et, si elle échoue, garde ce qui est affiché
      const isSilent = silent === true && !!this.data;
      if (!isSilent) this.isLoading = true;
      const resp = await this.load();
      if (requestId !== this.requestId) return;
      const failed = !resp || !!resp.errors;
      if (!failed) this.data = resp;
      if (!isSilent || !failed) this.hasFailed = failed;
      this.isLoading = false;
    },
    refresh() {
      return this.fetch(true);
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.panel
  position relative
  margin-top 14px

.content
  transition opacity .15s

  &.stale
    opacity .55

.notice
  display flex
  justify-content center
  padding 40px 20px
  text-align center
  color CTRL_TEXT_MUTED
  background white
  border 1px dashed #dbe1ec
  border-radius 14px

.loading
  position absolute
  top 0
  right 0
  padding 5px 12px
  font-size 12px
  font-weight 600
  color THEME_COLOR_PRIMARY
  background rgba(255,255,255,.9)
  border-radius 20px
</style>
